import { TABLE_HEADER_CLASS } from '@/styles/dataTableBg';

export const ACTIONS_COLUMN_ID = 'actions';

export const SERIAL_COLUMN_ID = 'serial';

export const BODY_CELL_PADDING_CLASS = 'px-4 py-1.5';

export const BODY_ROW_CLASS =
  'h-12 bg-card transition-colors [&>td]:border-b [&>td]:border-border/50';

export const TABLE_BORDER_MODEL_CLASS = 'border-separate border-spacing-0';

export const DIALOG_TABLE_FRAME_CLASS = 'max-h-80 ring-primary/25 lg:min-h-0';

export const FEW_ROWS_TABLE_FRAME_CLASS = 'lg:min-h-0';

export const TABLE_VISIBLE_WIDTH_VAR = '--table-visible-width';

export const TABLE_VISIBLE_WIDTH_CLASS = 'w-(--table-visible-width)';

export const STICKY_TABLE_HEADER_CLASS = `sticky top-0 z-20 ${TABLE_HEADER_CLASS} [&_tr]:border-b-0`;

export const STICKY_TABLE_FOOTER_CLASS = `sticky bottom-0 z-20 border-t-0 ${TABLE_HEADER_CLASS} [&_tr]:border-b-0`;
